// aspect ratio helpers for menu thumbnails

// allowed difference between an image's ratio and the required one (2%)
const RATIO_TOLERANCE = 0.02;

const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));

// e.g. 1920x1080 -> "16:9"; odd sizes fall back to a decimal like "1.53:1"
export const getRatioLabel = (width, height) => {
  if (!width || !height) return "-";
  const divisor = gcd(width, height);
  const w = width / divisor;
  const h = height / divisor;
  return w <= 32 && h <= 32 ? `${w}:${h}` : `${(width / height).toFixed(2)}:1`;
};

// ratio is { width, height }, e.g. { width: 3, height: 2 }
export const matchesRatio = (item, ratio) => {
  if (!item?.width || !item?.height) return false;
  const required = ratio.width / ratio.height;
  return Math.abs(item.width / item.height - required) / required <= RATIO_TOLERANCE;
};
